"use strict";

exports.__esModule = true;
exports.MetricValueAggregateElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Metrics = require("../../../Catalogs/Metrics");
var _Calendar = require("../../Calendar");
var _Core = require("../../Core");
var _Device = require("../../Device");
var _Measures = require("../../Measures");
var _Metrics2 = require("../../Metrics");
var _Time = require("../../Time");
var _common = require("../common");
var _API = require("../../API");
var _constants = require("../../constants");
var _dec, _dec2, _dec3, _dec4, _dec5, _class, _MetricValueAggregateElement;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var CenterElement = _styledComponents["default"].div.withConfig({
  displayName: "MetricValueAggregateElement__CenterElement",
  componentId: "sc-fa9hf8-0"
})(["display:flex;flex:1;flex-direction:column;justify-content:center;align-items:center;"]);
function metricQueryBuilder(devices, metric, startMillis, endMillis) {
  // FIXME: Add all query definitions in vimana-typesĻ
  var buildQuery = (0, _Metrics.buildMetricQuery)([metric]);
  buildQuery.filterByDevice(devices.map(function (device) {
    return device.uuid;
  }));
  buildQuery.filterByRange(new Date(startMillis).toISOString(), new Date(endMillis).toISOString());
  buildQuery.aggregateBy(["device"]);
  return buildQuery;
}

/**
 * Displays a particular metric value for a device.
 */
var MetricValueAggregateElement = exports.MetricValueAggregateElement = (_dec = _Time.ReportingPeriodContext.withContext, _dec2 = _Time.TimeContext.withContext, _dec3 = _Calendar.CalendarContext.withContext, _dec4 = _Core.SelectionContext.withContext, _dec5 = _Device.DeviceListContext.withContext, _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = (_MetricValueAggregateElement = /*#__PURE__*/function (_Component) {
  function MetricValueAggregateElement(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.renderMetric = function (_ref) {
      var color = _ref.color,
        backgroundColor = _ref.backgroundColor;
      var _this$props = _this.props,
        metricName = _this$props.metricName,
        devices = _this$props.devices,
        reportingPeriod = _this$props.reportingPeriod,
        dataRange = _this$props.dataRange,
        selection = _this$props.selection;
      var selectedPeriod = dataRange === "SELECTION" && selection && selection.selected.reportingPeriod ? selection.selected.reportingPeriod.interval : reportingPeriod.interval;
      var startMillis = selectedPeriod.startMillis,
        endMillis = selectedPeriod.endMillis;
      var metric = (0, _Metrics.getMetricDefinition)(metricName);
      var buildQuery = metricQueryBuilder(devices, metric.name, startMillis, endMillis);
      var renderValue = function renderValue(fetching, error, data) {
        if (fetching) {
          return /*#__PURE__*/_react["default"].createElement(CenterElement, null, /*#__PURE__*/_react["default"].createElement(_Core.Spinner, {
            size: _core.Spinner.SIZE_SMALL
          }));
        } else if (error) {
          return /*#__PURE__*/_react["default"].createElement(CenterElement, null, /*#__PURE__*/_react["default"].createElement(_core.Icon, {
            icon: _icons.IconNames.WARNING_SIGN,
            size: 16,
            intent: _core.Intent.DANGER
          }), /*#__PURE__*/_react["default"].createElement(_Core.Text, {
            muted: true
          }, metric.shortLabel || metric.name));
        }
        return _this.renderMeasurementValue({
          color: color,
          backgroundColor: backgroundColor,
          value: _this.calculateAggregate(data)
        });
      };
      return /*#__PURE__*/_react["default"].createElement(_Metrics2.MetricQueryController, {
        query: buildQuery.getQuery()
      }, function (_ref2) {
        var fetching = _ref2.fetching,
          error = _ref2.error,
          metricData = _ref2.data;
        var _ref3 = metricData || {},
          byDevice = _ref3.by_device;
        var data = byDevice || null;
        return renderValue(fetching, error, data);
      });
    };
    _this.renderSubscription = function (_ref4) {
      var color = _ref4.color,
        backgroundColor = _ref4.backgroundColor;
      return /*#__PURE__*/_react["default"].createElement(_API.RealtimeBatchSubscription, {
        channels: _this.getMetricChannels()
      }, function (results) {
        return _this.renderMeasurementValue({
          color: color,
          backgroundColor: backgroundColor,
          value: _this.calculateAggregate(results)
        });
      });
    };
    _this.calculateAggregate = function (data) {
      var _this$props2 = _this.props,
        aggregationType = _this$props2.aggregationType,
        includeDevicesIntoCalculation = _this$props2.includeDevicesIntoCalculation,
        devices = _this$props2.devices,
        metricName = _this$props2.metricName;
      if (data) {
        var result = 0;
        var sum = 0;
        var nonzeroValuesCount = 0;
        // A device whose realtime channel has not delivered yet is `undefined`,
        // and the metrics publisher sends `null` for a ratio with nothing to
        // divide yet (every shift and workday start). Both count as zero, as the
        // "include zero/no value" option promises, and neither is a value when
        // that option is off.
        for (var _i = 0, _Object$values = Object.values(data); _i < _Object$values.length; _i++) {
          var entry = _Object$values[_i];
          var value = entry == null ? void 0 : entry.value;
          sum += value != null ? value : 0;
          if (value !== 0 && value !== null && value !== undefined) nonzeroValuesCount++;
        }
        if (aggregationType === "SUM") result = sum;else {
          if (includeDevicesIntoCalculation) result = sum / ((devices == null ? void 0 : devices.length) > 0 ? devices == null ? void 0 : devices.length : 1);else result = sum / (nonzeroValuesCount > 0 ? nonzeroValuesCount : 1);
        }
        var units = (0, _Metrics.getUnitForMetric)(metricName);
        return isNaN(result) ? 0 : units === _constants.METRICS_MILLISECOND ? Math.round(result) : result;
      } else {
        return 0;
      }
    };
    _this.state = {
      devicesValue: []
    };
    return _this;
  }
  _inheritsLoose(MetricValueAggregateElement, _Component);
  var _proto = MetricValueAggregateElement.prototype;
  _proto.render = function render() {
    var _devices$;
    var _this$props3 = this.props,
      devices = _this$props3.devices,
      color = _this$props3.color,
      time = _this$props3.time,
      reportingPeriod = _this$props3.reportingPeriod,
      selection = _this$props3.selection,
      dataRange = _this$props3.dataRange,
      backgroundColor = _this$props3.backgroundColor,
      backgroundColorSource = _this$props3.backgroundColorSource,
      calendar = _this$props3.calendar;
    var selectedPeriod = dataRange === "SELECTION" && selection && selection.selected.reportingPeriod ? selection.selected.reportingPeriod.interval : reportingPeriod.interval;
    var shift = calendar && calendar.calendar.getEventAt(Date.now(), {
      type: "Shift",
      deviceUUID: (_devices$ = devices[0]) == null ? void 0 : _devices$.uuid
    });
    var shiftInterval = shift ? shift.interval : time.currentShift.interval;
    var component = (0, _Metrics.canSubscribeToRealtime)(time.currentWorkday.interval, shiftInterval, selectedPeriod) ? this.renderSubscription : this.renderMetric;
    if (backgroundColorSource) {
      var _devices$2;
      return /*#__PURE__*/_react["default"].createElement(_Device.DeviceColorController, _extends({
        deviceUuid: (_devices$2 = devices[0]) == null ? void 0 : _devices$2.uuid
      }, (0, _common.getWidgetColorProps)(this.props)), component);
    }
    return component({
      color: color,
      backgroundColor: backgroundColor
    });
  };
  _proto.mapAggregationTypeShortName = function mapAggregationTypeShortName(aggregationType) {
    switch (aggregationType) {
      case "AVERAGE":
        return "Avg.";
      case "SUM":
        return "Sum";
      default:
        return "";
    }
  };
  _proto.renderMeasurementValue = function renderMeasurementValue(_ref5) {
    var color = _ref5.color,
      backgroundColor = _ref5.backgroundColor,
      value = _ref5.value;
    var _this$props4 = this.props,
      metricName = _this$props4.metricName,
      hideLabel = _this$props4.hideLabel,
      aggregationType = _this$props4.aggregationType;
    var metric = (0, _Metrics.getMetricDefinition)(metricName);
    var label = this.mapAggregationTypeShortName(aggregationType) + " " + (metric.shortLabel || metric.name);
    return /*#__PURE__*/_react["default"].createElement(_Measures.MeasurementValue, _extends({
      value: value,
      units: metric.units,
      label: !hideLabel && label,
      color: color || "currentColor",
      backgroundColor: backgroundColor
    }, (0, _common.getWidgetFontProps)(this.props), (0, _common.getWidgetPositionProps)(this.props), (0, _common.getWidgetInteractionProps)(this.props)));
  };
  _proto.getDevices = function getDevices() {
    var devices = this.props.devices;
    return devices || [];
  };
  _proto.getMetricChannels = function getMetricChannels() {
    var _this2 = this;
    return this.getDevices().reduce(function (channels, device) {
      return Object.assign(channels, _this2.getDeviceMetricChannels(device));
    }, {});
  };
  _proto.getDeviceMetricChannels = function getDeviceMetricChannels(device) {
    var _this$props5 = this.props,
      metricName = _this$props5.metricName,
      reportingPeriod = _this$props5.reportingPeriod;
    var channels = {};
    var metric = (0, _Metrics.getMetricDefinition)(metricName);
    channels[device.uuid + ":" + metricName] = ["metric", {
      entity: {
        device: device.uuid,
        name: metric.name,
        period: reportingPeriod && reportingPeriod.name === "shift" ? "shift" : "workday"
      }
    }];
    return channels;
  };
  return MetricValueAggregateElement;
}(_react.Component), _MetricValueAggregateElement.defaultProps = {
  reportingPeriod: undefined,
  selection: undefined,
  calendar: undefined,
  time: undefined,
  devices: undefined
}, _MetricValueAggregateElement)) || _class) || _class) || _class) || _class) || _class);